import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NewsDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  // 模拟新闻数据
  const news = {
    id: 1,
    title: '公司成功举办2024年度技术创新大会',
    date: '2024-03-15',
    category: '公司新闻',
    author: '张明',
    content: `
      <p>2024年3月15日，我司成功举办了2024年度技术创新大会。本次大会以"创新驱动发展，科技引领未来"为主题，吸引了来自全国各地的行业专家、合作伙伴和媒体代表参加。</p>
      
      <h2>大会亮点</h2>
      <p>在本次大会上，我们展示了公司在以下领域的最新研发成果：</p>
      <ul>
        <li>人工智能技术的最新突破</li>
        <li>云计算解决方案的创新应用</li>
        <li>大数据分析平台的升级优化</li>
        <li>物联网技术的实践案例</li>
      </ul>
      
      <h2>未来展望</h2>
      <p>公司将继续加大研发投入，深化技术创新，为客户提供更优质的产品和服务。我们期待与更多合作伙伴携手共进，共同推动行业技术进步。</p>
    `,
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80',
    relatedNews: [
      {
        id: 2,
        title: '新一代智能产品发布会圆满成功',
        date: '2024-03-10',
        image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      },
      {
        id: 3,
        title: '公司与多家知名企业达成战略合作',
        date: '2024-03-05',
        image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
      }
    ]
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {/* 面包屑导航 */}
      <nav className="text-sm mb-8">
        <Link to="/" className="text-gray-500 hover:text-blue-600">
          首页
        </Link>
        <span className="mx-2 text-gray-400">/</span>
        <Link to="/news" className="text-gray-500 hover:text-blue-600">
          新闻动态
        </Link>
        <span className="mx-2 text-gray-400">/</span>
        <span className="text-gray-700">{news.title}</span>
      </nav>

      {/* 文章头部 */}
      <motion.article
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-lg overflow-hidden"
      >
        <div className="relative h-96">
          <img
            src={news.image}
            alt={news.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="text-center text-white">
              <h1 className="text-4xl font-bold mb-4">{news.title}</h1>
              <div className="flex items-center justify-center space-x-4 text-sm">
                <span>{news.date}</span>
                <span>•</span>
                <span>{news.author}</span>
                <span>•</span>
                <span>{news.category}</span>
              </div>
            </div>
          </div>
        </div>

        {/* 文章内容 */}
        <div className="p-8">
          <div 
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: news.content }}
          />
        </div>
      </motion.article>

      {/* 相关新闻 */}
      <section className="mt-16">
        <h2 className="text-2xl font-bold mb-8">相关新闻</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {news.relatedNews.map((item) => (
            <Link 
              key={item.id} 
              to={`/news/${item.id}`}
              className="group"
            >
              <motion.article
                whileHover={{ y: -5 }}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 group-hover:text-blue-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="text-sm text-gray-500">
                    {item.date}
                  </div>
                </div>
              </motion.article>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default NewsDetail; 